// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"f4f54114","58":"86c79d19","196":"aef33fa9","200":"d31bdabc","349":"0c6c0b52","378":"89d6a48e","394":"c81998c3","488":"9c92ff38","546":"99f7dba7","722":"7a01af72"}[chunkId] + ".chunk.js";
};